import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewPrescripcionMobile = () => import('./Index.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'prescripcion_mobile',
        name: 'PrescripcionMobile',
        component: ViewPrescripcionMobile,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router